// extracted by mini-css-extract-plugin
module.exports = {"fancyDate":"FancyDate_fancyDate__VbDtH","weekdayLabel":"FancyDate_weekdayLabel__bdRwV","saturday":"FancyDate_saturday__7qQIB","sunday":"FancyDate_sunday___1N0e"};